import { ITenantImageQuery } from '../interfaces/tenant-image.query.interface';

export class TenantImage {
    id: string;
    inLibrary: boolean;
    selected: boolean;
    unsplash: {
        unsplashId: string;
        authorName: string;
        authorProfileUrl: string;
    } = { unsplashId: '', authorName: '', authorProfileUrl: '' };
    url: string;
    parentUrl: string;
    thumbUrl: string;
    mimeType: string;
    name: string;
    originalName: string;

    constructor(query: ITenantImageQuery) {
        this.id = query.id.toString();
        this.inLibrary = query.in_library;
        this.selected = false;
        if (query.unsplash) {
            this.unsplash.unsplashId = query.unsplash.unsplash_id.toString();
            this.unsplash.authorName = query.unsplash.author_name;
            this.unsplash.authorProfileUrl = query.unsplash.author_profile_url;
        } else {
            this.unsplash = null;
        }
        this.url = query.url;
        this.parentUrl = query.parent_url;
        this.thumbUrl = query.thumb_url;
        this.mimeType = query.mime_type;
        this.name = query.name;
        this.originalName = query.original_name;
    }
}
